import { Button, Card, Col, Row } from "reactstrap";
import IconInput from "../../components/inputs/IconInput";
import { MdOutlineEmail } from "react-icons/md";
import { IoLockClosed } from "react-icons/io5";

import NormalInput from "../../components/inputs/NormalInput";
import IconedDropdownInput from "../../components/inputs/IconedDropdownInput";
import { TbUserExclamation } from "react-icons/tb";
import useAuthHooks from "../../hooks/useAuthHooks";
import CountryCitySelect from "../../components/inputs/countryCitySelect/CountryCitySelect";
import ErrorModal from "../../components/modals/ErrorModal";
import { AuthHalfScreenComp } from "../../components/commonComponents";
import { useTranslation } from "../../languages";

const Signup = ({ onAuthSuccess }) => {
  const {
    //all local states
    signupCredentials,
    setSignupCredentials,

    //all functions
    onPressRegisterBtn,
  } = useAuthHooks(onAuthSuccess);
  const { t } = useTranslation();
  return (
    <Row className="full-screen p-0 m-0">
      <AuthHalfScreenComp infoModal />
      <Col
        md={6}
        lg={5}
        className="d-flex py-3 align-items-center  m-0 justify-content-center"
      >
        <Card className="bg-transparent border-none full-width mx-xl-5 mx-4">
          <h4 className="f-7">{t("hello")} !</h4>
          <h5 className="f-4">{t("signUpToGetStarted")} </h5>
          <div className="mt-3 mb-4">
            <NormalInput
              value={signupCredentials?.firstName}
              className={"mb-3"}
              // error={signupErrors?.firstName}
              setValue={(v) =>
                setSignupCredentials((prev) => ({ ...prev, firstName: v }))
              }
              placeholder={"First Name"}
            />
            <NormalInput
              value={signupCredentials?.lastName}
              className={"mb-3"}
              setValue={(v) =>
                setSignupCredentials((prev) => ({ ...prev, lastName: v }))
              }
              placeholder={"Last Name"}
            />
            <IconedDropdownInput
              Icon={TbUserExclamation}
              iconSize={30}
              placeholder={"Role"}
              className={"mb-3"}
              value={signupCredentials?.role}
              setValue={(v) =>
                setSignupCredentials((prev) => ({ ...prev, role: v }))
              }
              options={["contributor", "user"]}
            />
            <IconInput
              Icon={MdOutlineEmail}
              className={"mb-3"}
              type={"email"}
              placeholder={"Email Address"}
              value={signupCredentials?.email}
              setValue={(v) =>
                setSignupCredentials((prev) => ({ ...prev, email: v }))
              }
            />
            <CountryCitySelect
              country={signupCredentials?.country}
              city={signupCredentials?.city}
              setCountry={(v) =>
                setSignupCredentials((prev) => ({ ...prev, country: v }))
              }
              setCity={(v) =>
                setSignupCredentials((prev) => ({ ...prev, city: v }))
              }
            />
            <IconInput
              Icon={IoLockClosed}
              className={"mb-3"}
              type={"password"}
              placeholder={"Create Password"}
              value={signupCredentials?.password}
              setValue={(v) =>
                setSignupCredentials((prev) => ({ ...prev, password: v }))
              }
            />
            <IconInput
              Icon={IoLockClosed}
              type={"password"}
              placeholder={"Confirm Password"}
              value={signupCredentials?.confirmPassword}
              setValue={(v) =>
                setSignupCredentials((prev) => ({
                  ...prev,
                  confirmPassword: v,
                }))
              }
            />
          </div>
          <Button
            onClick={() => onPressRegisterBtn()}
            className="standard-rounded-btn mb-4 full-width"
          >
            {t("register")}
          </Button>
          {/* <ErrorToast message={signupCredentials?.error} /> */}
          <ErrorModal
            isOpen={signupCredentials?.error}
            toggle={() =>
              setSignupCredentials((prev) => ({ ...prev, error: "" }))
            }
            errorMessage={signupCredentials?.error}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default Signup;
